import React from "react";
import OrganigramaTemplate from "../components/templates/OrganigramaTemplate";

const OrganigramaPage = () => {
	return <OrganigramaTemplate />;
};

export default OrganigramaPage;
